import {createAction} from "@reduxjs/toolkit";

export const onConfirmBooleanDialogAction = createAction<boolean>('onBooleanDialogAction');
export const onConfirmTextDialogAction = createAction<string | undefined>('onTextDialogAction');
